<template>
  <div class="mb-5">
    <form>
      <div class="form-group">
        <label for="trackHeightRange" style="font-size: 1.25rem; color: #17A2B8">
          {{label}}
        </label>
        <input type="range" class="form-control-range" id="trackHeightRange"
        :min="minHeight" :max="maxHeight" v-model="selected">
        <b-row class="justify-content-between">
          <b-col style="color: blue; font-size: .55rem;">10</b-col>
          <b-col style="text-align: center; color: #17A2B8; font-size: 1.25rem;">
            {{selected}}
          </b-col>
          <b-col style="text-align: right; color: red; font-size: .55rem;">80</b-col>
        </b-row>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: 'Choose track height'
    },
    minHeight: {
      type: Number,
      default: 10
    },
    maxHeight: {
      type: Number,
      default: 80
    }
  },
  data() {
    return {
      selected: 30
    }
  }
}
</script>

<style>

</style>